import { useCallback, useEffect, useState } from 'react';
import ContactResource from 'Resources/Contact';

/** What the CRM already holds for a contact: shown on its card, and not looked up again. */
export type CrmContactInfo = { email: string; cellPhone: string; phone: string };

/**
 * The email and numbers of the contact a LinkedIn profile already is (WEB-13771). The extension
 * showed only the profile's own fields, so a rep could pay to look up an email the CRM already had.
 * `reload` re-reads it after "Add to the contact" fills something in.
 */
export default function useCrmContactInfo(contactId: number | undefined) {
	const [info, setInfo] = useState<CrmContactInfo | null>(null);
	const [version, setVersion] = useState(0);

	useEffect(() => {
		setInfo(null);
		if (!contactId) return;
		let cancelled = false;
		ContactResource.get(contactId)
			.then(({ data }) => {
				if (cancelled) return;
				setInfo({ email: data.email ?? '', cellPhone: data.cellPhone ?? '', phone: data.phone ?? '' });
			})
			.catch((err: unknown) => {
				console.error('[EmbedAIChat] reading the CRM contact failed', { contactId, err });
			});
		return () => {
			cancelled = true;
		};
	}, [contactId, version]);

	const reload = useCallback(() => setVersion(current => current + 1), []);
	return { info, reload };
}
